<template>
    <app-content-admin>
        <template slot="header">Subscriber</template>
        <!-- <template slot="button">
            <v-btn
            style="margin-left:auto"
            large
            color="primary"
            to="/subscriber/add_subscriber"
            >
            + Add Subscriber
        </v-btn>

        </template> -->

        
        <v-layout row wrap>
           
            <v-flex xs12>
                <v-card class="p-3">
                    <table class="table table-fluid no-wrap">
                        <thead>
                            <th scope="col">User Id</th>
                            <th scope="col">Project Id</th>
                            <th scope="col">Username</th>
                            <th scope="col">Email</th>
                            <th scope="col">Role</th>
                            <!-- <th scope="col">Project ID</th>    -->
                            <th scope="col">Action</th>                       
                        </thead>
                        <tbody>
                            <tr class="text-center" v-for="(user,i) in displayedItems" :key="i">
                                <td :data-label="$t('User ID')">{{ user.id_user }}</td>
                                 <td :data-label="$t('Project ID')" class="text-truncate">{{ user.id_project }}</td>
                                <td :data-label="$t('Username')" class="text-truncate">{{ user.firstname }} {{ user.lastname }}</td>
                                <td :data-label="$t('Email')">{{ user.email }}</td>
                                <td :data-label="$t('Role')">{{ user.roles }}</td>
                                <!-- <td :data-label="$t('Project ID')" class="text-truncate">
                                   {{ user.id_project }}
                                </td>                               -->
                                <td :data-label="$t('action')">
                                    <v-menu :close-on-content-click="true" :nudge-width="200" :open-on-click="true" offset-y
                                        offset-x left>
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="primary" text small icon v-on="on">
                                                <v-icon>more_horiz</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="ViewUserDetail(user.id_user)">
                                                <v-list-item-action>
                                                    View
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item @click="deleteProject(user.id_user)">
                                                <v-list-item-action>
                                                    Delete
                                                </v-list-item-action>
                                            </v-list-item>
                                              <v-list-item @click="goToReset(user.id_user)">
                                                <v-list-item-action>
                                                    Reset Password
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <v-layout justify-center>
                        <v-flex xs8>
                            <div class="text-xs-center" v-if="pages > 0">
                                <v-pagination v-model="page" :length="pages" @input="onListChange"></v-pagination>
                            </div>
                        </v-flex>
                    </v-layout> -->
                </v-card>
                <v-pagination class="pagination mb-2" v-model="currentPage" :length="totalPages" @input="updatePage" :total-visible="7"></v-pagination>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from '../../components/status/ActiveLabel.vue';
import store from '@/store'

export default {
    mixins: [vForm],

    data(){
        return {              
              users:[],
              form: {
                  page: 1,
                  offset: 10,
              },
              itemsPerPage: 20, 
              currentPage: 1,       
          }
        },

        components: {ActiveLabel},

        computed:{
            totalPages() {
              return Math.ceil(this.users.length / this.itemsPerPage);
            },
             displayedItems() {
              const startIndex = (this.currentPage - 1) * this.itemsPerPage;
              const endIndex = startIndex + this.itemsPerPage;
              console.log(endIndex)
              return this.users.slice(startIndex, endIndex);
            },
        },

        created() {
            this.search();
        },

        methods: {

             updatePage(page) {
                this.currentPage = page;
            },

            search() {
              
                let loader = this.$loading.show();
                let token = store.getters['auth/token'];
                axios.get(`/api/auth/get_firebase_user_list?token=${token}`)
                    .then(res => res.data)
                    .then(res => {
                        this.users = res.data.result;
                        console.log(this.users);
                        //this.rows = res.data.data;
                        //this.pages = res.data.pages;
                     })
                    .catch((e)=>{
                        this.$toastr.e(e.message);
                    })
                    .finally(()=>{
                        loader.hide();
                    })
            },

            onListChange(page) {
                this.search(10, page);
            },

            async deleteProject(id) {
                let loader = this.$loading.show();

                try{
                 let token = store.getters['auth/token'];
                 let res = await axios.post(`/api/auth/delete_firebase_user?token=${token}`,{id_user:id})
                    if(res.data){
                     this.$toastr.s("Delete successfully");
                    }
                }
                catch(e){
                    this.$toastr.e(e.message);
                }
                finally{
                    loader.hide();
                    this.search();
                }
            },  
            
            ViewUserDetail(id)
            {
                this.$router.push({path:'/subscriber/view_subscriber/'+ id})
            },

           
            
        }
}
</script>